const initialState = {
  users: {
    isSignedIn: false,
    role: "",
    uid: "",
    username: "",
    fitMenus: {},
  },
  menus: {
    fitItems: [],
    partsId: [],
    date: "",
    days: "",
  },
};

export default initialState;
